import {Injectable} from '@angular/core';
import {AuthService} from '@auth/auth.service';
import {HttpService} from './http-service';
import {ConfigService} from './webFeeder/config.service';
import {timeout, map} from 'rxjs/operators';
import {BehaviorSubject, of} from 'rxjs';
import {Constants} from '@utils/constants';
import {WorksheetShareModel} from '@model/worksheet-share.model';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WorksheetShareService {

  public _reloadWorksheetAfterNewAction = new BehaviorSubject<any>(null);
  reloadWorksheetAfterNewAction$ = this._reloadWorksheetAfterNewAction.asObservable();

  constructor(
    private _httpService: HttpService,
    private _httpClient: HttpClient,
    private _configService: ConfigService,
    private _authService: AuthService,
  ) {
  }

  getWorksheetsShare(isDefaultWkstShare: boolean) {
    const username = isDefaultWkstShare ? Constants.WKSHT_USER_PROFILE :
      this._configService.getUserMarketData() ? this._configService.getUserMarketData().login :
        this._authService.getUserLogged();
    if (username) {
      // const isTokenUserMultiBroker = this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ? true : false;
      // return this._httpService
      //   .doGet(this._configService.getApiWorkspace(), 'api/' + username + '/workspace/mobile', null, isTokenUserMultiBroker)
      //   .pipe(timeout(20000),
      //     map((res: any) => {
      //       return res;
      //     })
      //   );
      return this._httpClient.get(this._configService.getApiWorkspace() + '/api/' + username + '/workspace/mobile')
        .pipe(timeout(20000), map((res: any) => {
          return res.Data;
        })) as any;
    }
  }

  newWorksheetShare(assets, nameWks: string) {
    const userName = this._configService.getUserMarketData() ? this._configService.getUserMarketData().login : this._authService.getUserLogged();
    if (!userName) {
      throw new Error(Constants.WORKSHEET_MSG007);
    }
    const newWksht: WorksheetShareModel = {
      UserName: userName,
      Title: nameWks,
      Assets: assets && assets.length > 0 ? assets : [],
      ComponentType: Constants.WINDOW_NAME_WORK_SHEET,
      Type: 0
    };
    // const isTokenUserMultiBroker = this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ? true : false;
    // return this._httpService
    //   .doPost(this._configService.getApiWorkspace(), 'api/workspace/mobile', JSON.stringify(newWksht), false, null, isTokenUserMultiBroker)
    //   .pipe(map(response => {
    //     if (response) {
    //       return response;
    //     }
    //     return null;
    //   }));
    return this._httpClient.post(this._configService.getApiWorkspace() + '/api/workspace/mobile', newWksht).pipe(map((res: any) => {
      return res.Data;
    }));
  }

  updateWorksheetShare(wksht: WorksheetShareModel) {
    if (wksht && wksht.Id) {
      const isTokenUserMultiBroker = this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ? true : false;
      return this._httpService
        .doPatch(this._configService.getApiWorkspace(), 'api/workspace/mobile/' + wksht.Id, JSON.stringify(wksht), false, isTokenUserMultiBroker)
        .pipe(map(response => {
          if (response) {
            return response;
          }
          throw new Error(Constants.WORKSHEET_MSG004);
        }));
    }
  }

  deleteWorksheetShare(id: Number) {
    if (id) {
      // const isTokenUserMultiBroker = this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ? true : false;
      // return this._httpService
      //   .doDelete(this._configService.getApiWorkspace(), 'api/workspace/mobile', id, false, isTokenUserMultiBroker)
      //   .pipe(map(msg => {
      //     if (msg && (msg.status === 200 || msg === 1)) {
      //       return msg;
      //     } else {
      //       throw new Error(Constants.WORKSHEET_MSG001);
      //     }
      //   }));
      return this._httpClient.delete(this._configService.getApiWorkspace() + '/api/workspace/mobile/' + id);
    } else {
      throw new Error(Constants.WORKSHEET_MSG001);
    }
  }


}



